/**
 * Uses customization domain, which is an array, to check array for objects where channel is equal to "WEB"
 *
 * @param domain CustomizationDomain, can be empty, deconstructs to get channel
 * @returns Returns customization domain object's where channel is equal to "WEB"
 *
 * @example
 * ```ts
 * getCustomizations(<Some-Customization-Domain-Object>)
 */
export const getCustomizations = (domain) => { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.filter(({ channel }) => channel === "WEB")) !== null && _a !== void 0 ? _a : null; };
//# sourceMappingURL=index.js.map